import { mapActions, mapMutations } from 'vuex'
import { REMOVE_LOAD } from 'vx/mutations'
import { noop } from 'lodash'
import { alert } from 'utils'
import $ from 'jquery'

export default {
  methods: {
    ...mapMutations('load', [REMOVE_LOAD]),
    ...mapActions('load', ['acceptLoad', 'declineLoad']),

    /**
     * Handle hiding the modal.
     *
     * @return void
     */
    handleCloseModal () {
      $('.modal-load-request').modal('hide')
    },

    /**
     * Handle approving the request.
     *
     * @return Promise
     */
    handleAcceptRequest () {
      return this.acceptLoad(this.load.id)
        .then(this.handleCloseModal)
        .then(this.showAcceptedAlert)
        .then(this.removeLoadFromState)
        .then(this.triggerEvents)
    },

    /**
     * Handle declining the request.
     *
     * @return Promise
     */
    handleDeclineRequest () {
      return alert.confirm({
        text: 'This load will be declined.',
        showLoaderOnConfirm: true,
        preConfirm: confirmed => {
          if (confirmed) {
            return this.declineLoad(this.load.id)
          }

          return Promise.reject()
        }
      })
      .then(this.handleCloseModal)
      .then(this.showDeclinedAlert)
      .then(this.removeLoadFromState)
      .then(this.triggerEvents)
      .catch(noop)
    },

    /**
     * Show an alert success message if the load was accepted.
     *
     * @return void
     */
    showAcceptedAlert () {
      alert.success({ text: 'Load request has been accepted.', timer: 2000 })
    },

    /**
     * Show an alert success message if the load was decline.
     *
     * @return void
     */
    showDeclinedAlert () {
      alert.success({ text: 'Load request has been declined.', timer: 2000 })
    },

    /**
     * Remove a load from the Vuex state.
     *
     * @return void
     */
    removeLoadFromState () {
      this[REMOVE_LOAD](this.load)
    },

    /**
     * Trigger events that allow us to hook into the accept/decline actions.
     *
     * @return void
     */
    triggerEvents () {
      this.$bus.$emit('updateNavigation')

      this.$bus.$emit('loadRequestAcceptedOrDeclined', this.load)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loads/load-request-actions-helpers.js